import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "./data";
import { Container, MaskText, Reveal, Overline } from "./primitives";

export const Faq = () => (
  <section id="faq" className="bg-white py-20 lg:py-32" data-testid="faq-section">
    <Container className="grid gap-12 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <Overline>Perguntas frequentes</Overline>
        <MaskText className="font-display mt-6 text-4xl font-bold leading-[1] tracking-[-0.035em] text-[#0F172A] sm:text-6xl"
          lines={["Antes de", <span className="text-[#1238CE]">começarmos.</span>]} />
      </div>
      <Reveal className="lg:col-span-7">
        <Accordion type="single" collapsible defaultValue="item-0" className="border-t border-slate-200">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-slate-200">
              <AccordionTrigger className="font-display py-6 text-left text-lg font-semibold text-[#0F172A] hover:text-[#1238CE] hover:no-underline sm:text-xl" data-testid={`faq-accordion-item-${i + 1}`}>
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-base leading-relaxed text-slate-600">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </Container>
  </section>
);
